import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function SparkleIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 14, 14);
  const a11y = resolveA11yProps(props);

  return (
    <svg
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width={width}
      height={height}
      {...rest}
      {...a11y}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M7.02786 0.810408C7.11795 0.546686 7.49103 0.546686 7.58111 0.810408L8.23732 2.7315C8.82226 4.44395 10.1676 5.78895 11.8805 6.37373L13.8022 7.02976C14.0659 7.11982 14.0659 7.4928 13.8022 7.58286L11.8805 8.23889C10.1676 8.82366 8.82226 10.1687 8.23732 11.8811L7.58111 13.8022C7.49103 14.0659 7.11795 14.0659 7.02786 13.8022L6.37166 11.8811C5.78672 10.1687 4.44135 8.82366 2.72844 8.23889L0.806822 7.58286C0.543028 7.4928 0.543028 7.11982 0.806822 7.02976L2.72844 6.37373C4.44135 5.78895 5.78672 4.44395 6.37166 2.7315L7.02786 0.810408Z"
        fill="currentColor"
      />
      <path
        d="M2.33527 0.071959C2.36804 -0.0239863 2.50378 -0.0239864 2.53655 0.071959L2.77528 0.770876C2.98809 1.39389 3.47755 1.88321 4.10073 2.09596L4.79984 2.33463C4.89581 2.3674 4.89581 2.50309 4.79984 2.53586L4.10073 2.77453C3.47755 2.98728 2.98809 3.47661 2.77528 4.09962L2.53655 4.79853C2.50378 4.89448 2.36804 4.89448 2.33527 4.79853L2.09653 4.09962C1.88373 3.47661 1.39426 2.98728 0.771086 2.77453L0.0719786 2.53586C-0.0239929 2.50309 -0.0239929 2.3674 0.0719786 2.33463L0.771086 2.09596C1.39426 1.88321 1.88373 1.39389 2.09653 0.770876L2.33527 0.071959Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SparkleIcon;
